import * as UserActions from '../actions/user.actions';
import { createReducer, on, Action, createFeatureSelector } from '@ngrx/store';
import { AuthData } from 'app/shared/model/auth-data.model';
import { AUTH_DATA_STATE_KEY, LAST_CONNECTED_EMAIL } from 'app/shared/model/local-storage-keys';


const lastAuthToken = localStorage.getItem(AUTH_DATA_STATE_KEY);
const lastAuthEmail = localStorage.getItem(LAST_CONNECTED_EMAIL);


export class AuthUserState {
    authData: AuthData;
}
let initialState: AuthUserState = {
    authData: { email: lastAuthEmail, ownerFullName: '', role: null, token: lastAuthToken, businessName: null,isAtn:null },
}

const createUserReducer = createReducer(
    initialState,

    on(UserActions.setAuthData, (state, { token, email, ownerFullName, businessName,isAtn }) => {
        localStorage.setItem(AUTH_DATA_STATE_KEY, token);
        if (email) {
            localStorage.setItem(LAST_CONNECTED_EMAIL, email);
        }
        return { ...state, authData: { token, email, ownerFullName, businessName,isAtn } };
    }),
    on(UserActions.setUserInfo, (state, { ownerFullName, businessName,isAtn }) => {
        return { ...state, authData: { ...state.authData, ownerFullName, businessName,isAtn } };
    }),
    on(UserActions.clearAuthData, (state) => {
        localStorage.removeItem(AUTH_DATA_STATE_KEY);
        return { ...state, authData: { email: lastAuthEmail, ownerFullName: '', role: null, token: '', businessName: '',isAtn:null } };
    }),
    on(UserActions.setLastEmail, (state, { email }) => {
        localStorage.setItem(LAST_CONNECTED_EMAIL, email);
        return { ...state, authData: { ...state.authData, email } };
    }),
);


export function userReducer(state: AuthUserState | undefined, action: Action) {
    return createUserReducer(state, action);
}

